/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    className: PropTypes.string,
};

const LinkedinIcon = ({ color = '#222', backgroundColor = '#FFF', className = null }) => (
    <svg
        width="34.18px"
        height="34.18px"
        viewBox="0 0 34.18 34.18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <rect fill={color} x="1.86" y="3.04" width="29.38" height="28.15" />
        <path
            fill={backgroundColor}
            d="M31.65,0H2.53C1.13,0,0,1.1,0,2.45v29.28c0,1.35,1.13,2.45,2.53,2.45h29.12c1.4,0,2.53-1.1,2.53-2.45V2.45c0-1.35-1.13-2.45-2.53-2.45ZM10.39,28.6h-5.11v-15.39h5.11v15.39ZM7.83,11.11h0s-.03,0-.03,0c-1.72,0-2.83-1.18-2.83-2.66s1.14-2.66,2.89-2.66,2.83,1.15,2.86,2.66c0,1.48-1.11,2.66-2.89,2.66ZM28.83,28.6h-5.11v-8.23c0-2.07-.74-3.48-2.59-3.48-1.41,0-2.25.95-2.62,1.87-.14.33-.17.79-.17,1.25v8.59h-5.11s.07-13.94,0-15.39h5.11v2.18c.68-1.05,1.9-2.54,4.61-2.54,3.36,0,5.89,2.2,5.89,6.92v8.82Z"
        />
    </svg>
);

LinkedinIcon.propTypes = propTypes;

export default LinkedinIcon;
